import { DesignSystemToken } from 'designSystem/types';
import { BorderRadiusTokenPreview } from './BorderRadiusTokenPreview';
import { ColorTokenPreview } from './ColorTokenPreview';
import { FontFamilyTokenPreview } from './FontFamilyTokenPreview';
import { FontSizeTokenPreview } from './FontSizeTokenPreview';
import { FontWeightTokenPreview } from './FontWeightTokenPreview';
import { LengthTokenPreview } from './LengthTokenPreview';
import { LineHeightTokenPreview } from './LineHeightTokenPreview';
import { OpacityTokenPreview } from './OpacityTokenPreview';
import { OtherTokenPreview } from './OtherTokenPreview';
import { ShadowTokenPreview } from './ShadowTokenPreview';
import { SpacingTokenPreview } from './SpacingTokenPreview';
import { TransitionTokenPreview } from './TransitionTokenPreview';
import * as S from './styles';

interface TokenCardProps {
	token: DesignSystemToken;
	selected?: boolean;
	onClick?: () => void;
}

export const TokenCard = ({ token, selected, onClick }: TokenCardProps) => {
	const renderPreview = () => {
		// Use SpacingTokenPreview for spacing category tokens
		if (token.category === 'spacing' && token.value.kind === 'length') {
			return <SpacingTokenPreview value={token.value} />;
		}

		switch (token.value.kind) {
			case 'color':
				return <ColorTokenPreview value={token.value} />;
			case 'length':
				return <LengthTokenPreview value={token.value} />;
			case 'shadow':
				return <ShadowTokenPreview value={token.value} />;
			case 'fontFamily':
				return <FontFamilyTokenPreview value={token.value} />;
			case 'fontSize':
				return <FontSizeTokenPreview value={token.value} />;
			case 'lineHeight':
				return <LineHeightTokenPreview value={token.value} />;
			case 'fontWeight':
				return <FontWeightTokenPreview value={token.value} />;
			case 'borderRadius':
				return <BorderRadiusTokenPreview value={token.value} />;
			case 'opacity':
				return <OpacityTokenPreview value={token.value} />;
			case 'transition':
				return <TransitionTokenPreview value={token.value} />;
			case 'number':
			case 'string':
				return <OtherTokenPreview value={token.value} />;
			default:
				return <OtherTokenPreview value={token.value as any} />;
		}
	};

	return (
		<S.TokenCard selected={selected} onClick={onClick}>
			{renderPreview()}
			<S.TokenName>{token.name}</S.TokenName>
		</S.TokenCard>
	);
};
